import { AsyncThunkAction } from "@reduxjs/toolkit";
import { Dispatch } from "react";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { AnyAction } from "redux";
import { RootState } from "./store";

export const useAppDispatch = () => useDispatch<Dispatch<AnyAction|AsyncThunkAction<any, any, {}>>>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;